(() => {
  'use strict';

  let scrollLockCount = 0;

  const scrollLock = {
    lock() {
      scrollLockCount += 1;
      if (scrollLockCount === 1) {
        document.body.classList.add('is-scroll-locked');
      }
    },
    unlock() {
      if (scrollLockCount === 0) return;
      scrollLockCount -= 1;
      if (scrollLockCount === 0) {
        document.body.classList.remove('is-scroll-locked');
      }
    }
  };

  window.MixedownUI = Object.freeze({
    scrollLock
  });
})();
